import React from 'react';
import AllReviewsSection from '../../../sections/AdminDashboard/ReviewManagement/AllReviews';

const AllReviews = () => {
  return <AllReviewsSection />;
};

export default AllReviews;


